import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import { checkPriority, checkWorkLocation, makeSideBarActive } from '../../utils/EllowUtils';
import * as CONSTANTS from '../../utils/CONSTANTS'
import { useNavigate } from 'react-router-dom';
import ApplyPositions from "./applyPositions";
import { getAPI } from "../../api/api";
import { getAllocatedto, postCandidateToJob } from './services';
import classnames from "classnames"; 
import { REACT_APP_JOB } from '../../utils/common';
import NotificationAlert from "../../components/notification";
import { getCandidates } from './services';
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';


function Positions() {

  const navigate = useNavigate()
  const location = useLocation();
  const { jobId }: any = location.state || ''
  const {companyName}:any = location.state || ''
  

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
  // const [jobId, setJobId] = useState <string> ()
  const [selected, setSelected] = React.useState<number>(0);
  const [jobMetadata, setJobMetadata] = useState<{
    resources: number , experienceRange: any , title: string, contractDuration : string , startDate: number , minimumBudget: number , maximumBudget: number , resourceCount: any, closedCount: any, lossCount: any, locationPreference: any
    billingType: string ,jobRole: {id: number, name: string} , coreSkills:[{skillId: number, skillName: string}] , otherSkills: [{skillId: number, skillName: string}], contractStartDate: any, priority: any, jobType: any
  }>()
  const [jobDetails, setJobDetails] = useState<any>([])
  const [resources, setResources] = useState<any>()
  const [total, setTotal] = useState<number>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [coreSkills, setCoreSkills] = useState<any>([])
  const [jobExperience, setJobExperience] = useState<any>({})
  const [jobType, setJobType] = useState<any>({})
  const [filterValues, setFiltervalues] = useState<any>({})
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [rateInMail, setRateInMail] = useState(false)
  const [fail, setFail] = useState<boolean>(false)
  let BreadcrumsValues = ['Positions', jobMetadata?.title + ' - ' + companyName]
  const [skillList, setSkillList] = useState<any>()
  const [jobRoleList, setJobRoleList] = useState<any>()

// 7126c895-8645-48ab-a15a-3563776ba9ae
  useEffect(() => {

    getAPI( REACT_APP_JOB + `/position/${jobId}`).then(
      (response) => { 
        if (response && response.status === 1) {
          setJobMetadata(response.data[0].job_metadata)
          setRateInMail(response.data[0].showRateInEmail)
          setJobDetails(response.data[0])
          // setJobId(response.data[0].job_id)

    let skills = response.data[0] && response.data[0].job_metadata && response.data[0].job_metadata.coreSkills.map((item: any) => {
      return item.skillName
    })
          setCoreSkills(skills)
          setJobExperience(response.data[0].job_metadata.experienceRange)
          setJobType(response.data[0].job_metadata.jobType)
          getAllCandidates(25, 1, '', skills, response.data[0].job_metadata.experienceRange, response.data[0].job_metadata.jobType)
  
          let experience = {
            from: response.data[0].job_metadata.experienceRange.min,
            to: response.data[0].job_metadata.experienceRange.max
     }     
          setFiltervalues({core_skills: skills, experience: experience})
        }
      }
    );
    getAllocation();
    viewedpageMixpanel();

    getAPI('https://api.ellow.io/common/api/v1/tg/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })
    
    getAPI('https://api.ellow.io/common/api/v1/tg/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })

  }, [])
  


  const getAllocation = () => {
    getAllocatedto().then((response) => {
      if (response && response.status === 1) {
        setAllocatedTo(
          response.data.map((item: any) => {
            return item.name;
          })
        );
      }
    });
  };

  const getPageChange = (pageSize: any, pageNumber: number) => {
    let body ={
      size: pageSize,
      from: pageNumber } 
      let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
      getAllCandidates(pageSize, page, '' , "",'','', '')
  }

  const getAllCandidates = (pageSize: number, pageNumber: number, searchValue: string, skills?: any, experienceRange?: any, job_type?: any, filters?: any) => { 

    let body ={}
    if (filters) {
      filters.resourcesToExcludeForJobId = jobId
      filters.inContract = false
      filters.resource_status = ["F3 - Verified"]
      filters.job_type = jobType
      body = {
        filters : filters ,
        sort : {
          // "sortBy": "provider",
          "sortOrder": "asc"
        }
      }
    }
    else {        
      body = {
        filters: {
          inContract: false,
          resourcesToExcludeForJobId: jobId,
          core_skills: skills,
          resource_status:["F3 - Verified"],
          job_type: job_type,
          experience: jobExperience ? {
            'from': experienceRange && experienceRange.min,
            'to': experienceRange && experienceRange.max
          } : undefined
        } ,
        sort : {
          // "sortBy": "provider",
          "sortOrder": "asc"
        }
      }
    }  
    getCandidates( 'allResource', pageSize, pageNumber, searchValue, body).then((resp: any) => {
      if( resp && resp.status === 1){
        setResources(resp.data) 
        setTotal(resp.count)
      }
    })
  }

  const searchChange = (e: string) => {
    
    getAllCandidates(25, 1, e, coreSkills, jobExperience, jobType)

  }

  const onSubmit = (data: any) => {
    
    postCandidateToJob(data).then((response: any) => {
      if (response && response.status === 1) {
        displayNotification() 
        setFail(false)
        response && response.data && response.data.candidateDetails && response.data.candidateDetails.length > 0 && response.data.candidateDetails.map((item: any, key: number) => {
          mixpanelData('TG - Candidate Applied', {
            'source': 'Candidate applied to a position',
            'Position Name': response.data.positionName,
            'Recruiter Name': response.data.userName,
            'distinct_id': localStorage.getItem('Email'),
            'Recruiter Email': localStorage.getItem('Email'),
            'Resource Name': item.firstname + " " +  item.lastname,
            'ellow rate': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata && data.candidateMetadata[key].candidateJobMetadata.ellowRate ,
            'jobId': data.jobId,
            'candidateId': item.candidateId,
            'candidate Experience': item.workexperience,
            'submitted to email': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].toEmail && data.candidateMetadata[key].toEmail.toString(),
            'Additional emails submitted to': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].ccEmail && data.candidateMetadata[key].ccEmail.toString(),
            'Ellow rate enabled in the email': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].ellowRateInEmail,
            'Comments': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata && data.candidateMetadata[key].candidateJobMetadata.comment,
            'candidate Email': item.email,
            'company Name': response.data.companyName,
            'candidate Skills': item.skills && item.skills.length > 0 && item.skills.map((skill: any) => skill.skill && skill.skill.skillName).toString(),            
          })
          mixpanelData('New TG - Candidate Applied', {
            'source': 'Candidate applied to a position',
            'Position name': response.data.positionName,
            'Recruiter name': response.data.userName,
            'distinct_id': localStorage.getItem('Email'),
            'Recruiter email': localStorage.getItem('Email'),
            'Candidate name': item.firstname + " " +  item.lastname,
            'ellow rate': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata && `${data.candidateMetadata[key].candidateJobMetadata.ellowRate} ${data.candidateMetadata[key].candidateJobMetadata.currencyType} / ${data.candidateMetadata[key].candidateJobMetadata.billingType}` ,
            'JobId': data.jobId,
            'Candidate experience': item.workexperience,
            'Submitted to email': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].toEmail && data.candidateMetadata[key].toEmail,
            'Additional emails submitted to': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].ccEmail && data.candidateMetadata[key].ccEmail,
            'Ellow rate enabled in the email': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].ellowRateInEmail,
            'Comments': data && data.candidateMetadata && data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata && data.candidateMetadata[key].candidateJobMetadata.comment,
            'Candidate email': item.email,
            'Company name': response.data.companyName,
            'Candidate skills': item.skills && item.skills.length > 0 && item.skills.map((skill: any) => skill.skill && skill.skill.skillName),  
            'Job type': data.jobType,
            'Resource cost': data.candidateMetadata[key] && `${data.candidateMetadata[key].candidateJobMetadata.resourceRate} ${data.candidateMetadata[key].candidateJobMetadata.currencyType} / ${data.candidateMetadata[key].candidateJobMetadata.billingType}`,
            'Candidate loginid': data.candidateMetadata[key] && data.candidateMetadata[key].candidateId,
            'ellow rate in email': data.candidateMetadata[key] && data.candidateMetadata[key].candidateJobMetadata.ellowRateInEmail
          })
      })
      }
      else {
        setFail(true)
       
          }
    })
  }

  const displayNotification = () => {
    setMessage('Candidate Submitted Successfully')
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      navigate('../position-details',{ state: { jobId: jobId, positionName:jobMetadata?.title, companyName:companyName, candidateApplied: true }})
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
  }
 
  const closeTag = (data: any) => {
    if (!data.experience) {
      setJobExperience(undefined)
    }
    setFiltervalues(data)
    getAllCandidates(25, 1, '', '', '','', data)
  }

  const applyFilter = (data: any) => {
    
    if (data.availability) {
      data.availability = data.availability.value
    }

    if (data.minimumBudget === '') {
      delete data.minimumBudget
    }
    setFiltervalues(data)
    getAllCandidates(25, 1, '', '', '', '', data)
    
  }
  

  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose } closable={true} >
        {message}
      </NotificationAlert> }
      <SideMenu menu={menu}/>
      <div className="dashboardContent">
        <DashboardHeader title={BreadcrumsValues} navigateTo="" searchChange={''} />
        <ApplyPositions jobMetadata={jobMetadata} onSubmit={onSubmit} data={resources} total={total} pageSize={getPageChange} jobId={jobId} searchChange={searchChange} filtervalues={filterValues} closeTag={closeTag} allocatedTo={allocatedTo} applyFilter={applyFilter} rateInMail={rateInMail} fail={fail} skillsList={skillList} jobRolesList={jobRoleList} />        
      </div>
    </section>
  )
}

export default Positions